import { render, staticRenderFns } from "./editionDetail.vue?vue&type=template&id=19e3e036&scoped=true&"
import script from "./editionDetail.vue?vue&type=script&lang=js&"
export * from "./editionDetail.vue?vue&type=script&lang=js&"
import style0 from "./editionDetail.vue?vue&type=style&index=0&id=19e3e036&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e3e036",
  null
  
)

export default component.exports